import React from 'react'

import { Box, Display, FlexDirection } from '@gousto-internal/citrus-react'
import { useSelector } from 'react-redux'

import { NavBar } from '@library/menu-page'

import { useCollectionShortTitle, useSelectCollection } from 'hooks/menu-collections'
import Loading from 'routes/Menu/Loading'
import { BrowseScreen } from 'routes/Menu/MenuExperience/BrowseScreen'
import { SubHeaderContainer } from 'routes/Menu/components/SubHeader'
import { CollectionId, CollectionSlug } from 'routes/Menu/domains/collections'
import { useMenuPreferences } from 'routes/Menu/domains/menu'
import { isMenuLoading } from 'routes/Menu/selectors/menu'
import { getBasketIsFlexOrder } from 'selectors/basket'

import { CollectionScreen } from '../CollectionScreen/CollectionScreen'
import { BackToBrowse } from './BackToBrowse'
import { useGlobalBootstrap } from './useGlobalBootstrap'
import { useMenuBootstrap } from './useMenuBootstrap'

type MenuPageProps = {
  params: {
    orderId?: string
  }
  location: {
    query: {
      collection?: string
      reload?: boolean
    }
  }
}
export const MenuPage = ({ params, location }: MenuPageProps) => {
  const { query } = location

  const showLoading = useSelector(isMenuLoading)
  const { data: menuPreferences, isLoading: menuPreferencesIsLoading } = useMenuPreferences()
  const isFlexOrder = useSelector(getBasketIsFlexOrder)

  const selectCollection = useSelectCollection()
  const collectionShortTitle = useCollectionShortTitle(CollectionId.Recommendations)
  const showBrowseCollection = !query?.collection || query.collection === CollectionSlug.Browse

  useMenuBootstrap({ query, params })

  useGlobalBootstrap()

  const links = [
    {
      text: collectionShortTitle,
      selected: query?.collection === CollectionSlug.Recommendations,
      onClick: () => selectCollection(CollectionId.Recommendations),
    },
    {
      text: 'Browse',
      selected: showBrowseCollection,
      onClick: () => selectCollection(CollectionId.Browse),
    },
    {
      text: 'All Recipes',
      selected: query?.collection === CollectionSlug.AllRecipes,
      onClick: () => selectCollection(CollectionId.AllRecipes),
    },
  ]

  const isNavBarVisible = links.some((link) => link.selected)

  if (showLoading || menuPreferencesIsLoading) {
    return (
      <Box data-testid="loading">
        <Loading loading />
      </Box>
    )
  }

  return (
    <Box data-testid="menuPage">
      <SubHeaderContainer />
      {isNavBarVisible && (
        <Box paddingBottom={6}>
          <NavBar links={links} />
        </Box>
      )}
      <Box maxWidth="1600px" paddingH={[1, 1, 6]} paddingV={[2, 2, 4]} style={{ margin: '0 auto' }}>
        {showBrowseCollection ? (
          <BrowseScreen />
        ) : (
          <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={4}>
            {!isNavBarVisible && <BackToBrowse />}
            <CollectionScreen menuPreferences={menuPreferences} isFlexOrder={isFlexOrder} />
          </Box>
        )}
      </Box>
    </Box>
  )
}
